__turbopack_context__.v({
  "container": "styles-module-scss-module__o1oKdG__container",
  "dept": "styles-module-scss-module__o1oKdG__dept",
  "desc": "styles-module-scss-module__o1oKdG__desc",
  "img": "styles-module-scss-module__o1oKdG__img",
  "name": "styles-module-scss-module__o1oKdG__name",
  "root": "styles-module-scss-module__o1oKdG__root",
});
